import { makeSelectUsername } from "../../lib/providers/auth-provider";
import { createSelector } from "reselect";
import { createMakeSelectCurrentPage } from "../../lib/providers/pagination-provider/selectors";

const selectProfileEntity = state => state.entities.user;
const selectEntityData = state =>
  state.entities.user ? state.entities.user.data || {} : {};

export const makeSelectAllUsers = paginationKey =>
  createSelector(
    [selectEntityData, createMakeSelectCurrentPage(paginationKey)()],
    (substate, page) => {
      if (!paginationKey) {
        return { ...substate };
      }

      if (page.length > 0)
        return page
          .map(id => {
            if (!substate[id]) {
              return null;
            }

            return { ...substate[id] };
          })
          .filter(row => row);

      return [];
    }
  );

export const makeSelectProfile = () =>
  createSelector(
    selectProfileEntity,
    makeSelectUsername(),
    (substate, username) => {
      return substate && substate.data ? substate.data[username] : null;
    }
  );

export const makeSelectUserError = () =>
  createSelector(selectProfileEntity, substate => {
    return substate.error;
  });

export const makeSelectIsUserLoading = () =>
  createSelector(selectProfileEntity, substate => {
    return substate ? substate.isLoading : false;
  });
